'use client';

import Script from 'next/script';

const plausibleDomain = process.env.NEXT_PUBLIC_PLAUSIBLE_DOMAIN;

/** Loads Plausible when NEXT_PUBLIC_PLAUSIBLE_DOMAIN is set (e.g. cadrinoerv.com). */
export function MarketingAnalytics() {
  if (!plausibleDomain) {
    return null;
  }

  return (
    <Script
      defer
      data-domain={plausibleDomain}
      src="https://plausible.io/js/script.js"
      strategy="afterInteractive"
    />
  );
}

export function trackMarketingEvent(eventName: string) {
  if (typeof window !== 'undefined' && 'plausible' in window) {
    (window as { plausible?: (e: string) => void }).plausible?.(eventName);
  }
}
